import { ContactFormData } from '@/views/ContactUs/subcomponents/ContactForm.schema';
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

export const sendContactMessage = async (data: ContactFormData) => {
  const response = await axiosClient.post(API_ENDPOINTS.CONTACT, data);
  return response.data;
};
